export enum RadioGroupSize {
    Default = 'default',
    Small = 'small',
    Large = 'large'
}
